"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMFWThemeMob = void 0;
var color_1 = __importDefault(require("color"));
exports.createMFWThemeMob = function (t) {
    return {
        primary: t.primary,
        background: t.mobBackground.background,
        card: t.mobBackground.card,
        text: t.text.primary,
        border: t.primary,
        notification: t.warning,
        primaryLight: color_1.default(t.primary).alpha(0.45).toString(),
        primaryDisabled: color_1.default(t.primary).alpha(0.35).toString(),
        backgroundLight: t.mobBackground.backgroundLight,
        backgroundOverlay: t.mobBackground.backgroundOverlay,
        text200: color_1.default(t.text.primary).alpha(0.8).toString(),
        text300: color_1.default(t.text.primary).alpha(0.6).toString(),
        text400: color_1.default(t.text.primary).alpha(0.4).toString(),
        text500: color_1.default(t.text.primary).alpha(0.2).toString(),
        secondary: t.secondary,
        tertiary: color_1.default(t.tertiary).alpha(0.85).toString(),
        delete: t.error,
        warning: t.warning,
        white: "white"
    };
};
//# sourceMappingURL=createMfwMobTheme.js.map